import React, { useState, useEffect } from "react";
import { Box, Typography, Grid, Container } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import SpeedIcon from '@mui/icons-material/Speed';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

import { url ,fileUploadUrl} from "../../../../constant";

const iconMap = {
  security: SecurityIcon,
  speed: SpeedIcon,
  support_agent: SupportAgentIcon,
  // Add more mappings here
};

const failurePlatformHeading = "Why Choose Our Platform";

// const getFeatureIcon = (iconName) => {
//   const IconComponent = iconMap[iconName] || SecurityIcon; // fallback
//   return <IconComponent color="primary" fontSize="large" sx={{ mb: 4 }} />;
// };

const getFeatureIcon = (iconName) => (
  <i
    className="material-icons"
    style={{ 
      fontSize: 36, 
      color: "rgb(233, 30, 99)" , // "#1976d2" 
      marginBottom: 16, display: 'inline-block' }}
  >
    {iconName}
  </i>
);

const failureFeatures = [
  {
    "id": 1,
    "icon": "security",
    "title": "Secure & Reliable",
    "description": "Our platform ensures top-notch security with continuous monitoring and data protection.",
  },
  {
    "id": 2,
    "icon": "speed",
    "title": "Fast Performance",
    "description": "Experience lightning-fast load times and seamless user experience across all devices.",
  },
  {
    "id": 3,
    "icon": "support_agent",
    "title": "24\/7 Support",
    "description": "Our expert team is always available to assist you with any questions or issues.",
  }
];

const FeaturesSection = () => {

  const [features, setFeatures] = useState([
    {
      "id": 1,
      "icon": "security",
      "title": "Secure & Reliable",
      "description": "Our platform ensures top-notch security with continuous monitoring and data protection.",
    },
    {
      "id": 2,
      "icon": "speed",
      "title": "Fast Performance",
      "description": "Experience lightning-fast load times and seamless user experience across all devices.",
    },
    {
      "id": 3,
      "icon": "support_agent",
      "title": "24\/7 Support",
      "description": "Our expert team is always available to assist you with any questions or issues.",
    }
  ]);
  
  const [platformHeading, setPlatformHeading] = useState("");
  const [loading, setLoading] = useState(false);
  

  useEffect(() => {
    fetchHeading();
    fetchPlatformFeatures();
  }, []);

  const fetchPlatformFeatures = async () => {
    try {
      setLoading(true);

      const response = await fetch(`${url}auth/get-platform-features`);
      if (!response.ok) throw new Error("Errore durante il recupero delle funzionalità");

      const result = await response.json();
      setFeatures(result || []);

      console.log("getPlatformFeatures", result);

    } catch (error) {
      
      console.error("Fetch error:", error.message);
      setFeatures(failureFeatures);

    } finally {
      setLoading(false);
    }
  };

  // Heading fetch karne ke liye
  const fetchHeading = () => {
    fetch(`${url}auth/platform-heading`)  // backend ka endpoint
      .then((res) => res.json())
      .then((data) => {

        setPlatformHeading(data.data || "Default Heading");
        console.log("/platform-heading", data);

      })
      .catch((err) => {
        console.error("Failed to fetch heading:", err)
        setPlatformHeading(failurePlatformHeading);

      });
  };

  return (
    <Box sx={{ py: { xs: 5, sm: 15, md: 4 }, backgroundColor: '#fff' }}>
      <Container maxWidth="lg">
        {/* Main Heading */}
        <Typography
          variant="h2"
          fontWeight="bold"
          align="center"
          gutterBottom
          sx={{ mb: 7 }}
        >
          {/* Why Choose Our Platform */}
          {platformHeading || failurePlatformHeading}
        </Typography>

        {/* Three Columns */}
        <Grid container spacing={2}>
         {loading ? (
          null
        ) : (
          features.map((feature, index) => (
            <Grid
              key={index}
              item
              xs={12}
              sm={4}
              sx={{
                px: { xs: 1, sm: 2 },
                mb: { xs: 4, sm: 0 },
              }}
            >
              <Box
                sx={{
                  borderTop: '4px solid #1976d2',
                  pt: { xs: 3, sm: 3 },
                  pb: 10,
                  px: { xs: 4, sm: 3 },
                  boxShadow: 3,
                  borderRadius: 1,
                  backgroundColor: '#fff',
                  height: '100%',
                }}
              >
                {getFeatureIcon(feature.icon)}
                <Typography variant="subtitle1" fontWeight="600" gutterBottom>
                  {feature.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {feature.description}
                </Typography>
              </Box>
            </Grid>
          ))
        )}
        </Grid>

      </Container>
    </Box>
  );
};

export default FeaturesSection;
